import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Avatar } from '@prezi/avatar';
import { Title } from './Common';
import { ResponsiveMode } from '../models/common';
import { boldTextStyle, baseTextStyle } from './Styles';
export function MetadataRow(props) {
  var rowStyle = {
    display: 'flex',
    position: 'relative'
  };
  var avatarStyle = {};
  var rightBlockStyle = {
    marginLeft: '9px'
  };
  var ownerLineStyle = _objectSpread(_objectSpread({}, boldTextStyle()), {}, {
    letterSpacing: 1,
    fontSize: 15
  });
  var modifiedDateStyle = _objectSpread(_objectSpread({}, baseTextStyle()), {}, {
    letterSpacing: 1.2
  });
  var _props$owner = props.owner,
    username = _props$owner.username,
    firstName = _props$owner.firstName,
    lastName = _props$owner.lastName;
  return React.createElement("div", {
    className: "viewer-common-metadata-row",
    style: rowStyle
  }, React.createElement("div", {
    className: "viewer-common-owner-avatar",
    style: avatarStyle
  }, React.createElement(Avatar, {
    size: 36,
    username: username,
    firstName: firstName,
    lastName: lastName
  })), React.createElement("div", {
    className: "viewer-common-metadata-right-block",
    style: rightBlockStyle
  }, React.createElement("div", {
    style: ownerLineStyle
  }, props.byOwner), React.createElement("div", {
    style: modifiedDateStyle
  }, props.lastModifiedDateString)));
}
export function MetadataBlock(props) {
  var margin = 0;
  var topMargin = 0;
  switch (props.responsiveMode) {
    case ResponsiveMode.LARGE:
      margin = 60;
      topMargin = 80;
      break;
    case ResponsiveMode.MIDDLE:
      margin = 30;
      topMargin = 80;
      break;
    case ResponsiveMode.SMALL:
      margin = 20;
      topMargin = 80;
      break;
    default:
      margin = 20;
      topMargin = 80;
      break;
  }
  var style = {
    position: 'absolute',
    top: topMargin,
    left: margin,
    right: margin
  };
  return React.createElement("div", {
    className: "viewer-common-metadata-block",
    style: style
  }, React.createElement(Title, {
    title: props.title,
    responsiveMode: props.responsiveMode
  }), React.createElement(ReactCSSTransitionGroup, {
    transitionName: "viewer-common-metadata",
    transitionAppear: true,
    transitionAppearTimeout: 500,
    transitionEnter: false,
    transitionLeave: false
  }, React.createElement(MetadataRow, {
    byOwner: props.byOwner,
    lastModifiedDateString: props.lastModifiedDateString,
    owner: props.owner
  })));
}